/**
 * Route
 * 由于react-router4 没有钩子 所以自己封装
 * 只需要在最父级 route
 * @author yuxin.zhang
 * @Date 2017-08-18
 */

import React from 'react';
import { Route } from 'react-router-dom';

import Page from '_common/constants/PageLink';
import history from '_common/history';
import Storage from '_common/utils/Storage';
import util from '_common/utils/util';

// 子账户需要拦截的路由 部分路由是key
const subInterceptKeyList = [
  {
    key: Page.rechargePage,
    backUrl: Page.myAssetsPage,
  },
  {
    key: Page.withdrawPage,
    backUrl: Page.myAssetsPage,
  },
  {
    key: Page.withdrawAddressPage,
    backUrl: Page.myAssetsPage,
  },
  {
    key: Page.fiAccountPage,
    backUrl: Page.myAssetsPage,
  },
  {
    key: Page.verification,
    backUrl: Page.security,
  },
  {
    key: Page.subAccount,
    backUrl: Page.security,
  },
  {
    key: Page.fee,
    backUrl: Page.security,
  },
  {
    key: Page.marketMaker,
    backUrl: Page.security,
  },
];

// 完全相等的url 拦截
const subInterceptLinkList = [
  {
    key: Page.users,
    backUrl: Page.security,
  },
];

/**
 * 子账户 部分路由拦截
 */
function subAccountIntercept() {
  const currentIsSub = Storage.get('currentIsSub') === '1';
  if (!currentIsSub) {
    return true;
  }
  for (let i = 0; i < subInterceptKeyList.length; i++) {
    if (window.location.href.indexOf(subInterceptKeyList[i].key) !== -1) {
      history.push(subInterceptKeyList[i].backUrl);
      return false;
    }
  }
  for (let i = 0; i < subInterceptLinkList.length; i++) {
    if (window.location.pathname === subInterceptLinkList[i].key) {
      history.push(subInterceptLinkList[i].backUrl);
      return false;
    }
  }
  return true;
}

/**
 * 浏览器判断
 * @returns {boolean}
 */
function lessThanIE11() {
  const UA = navigator.userAgent;
  const isIE = UA.indexOf('MSIE') > -1;
  const v = isIE ? /\d+/.exec(UA.split(';')[1]) : 11;
  return v < 11;
}

export default class OKRoute extends Route {
  UNSAFE_componentWillMount() {
    if (this.props.intercept) {
      this.onChange();
    }
  }

  shouldComponentUpdate() {
    if (this.props.intercept) {
      return this.onChange();
    }
    return true;
  }

  // 路由变化触发
  onChange = async () => {
    return new Promise((resolve) => {
      if (lessThanIE11()) {
        window.location.href = '/pages/products/browserUpdate.html';
        resolve(false);
      }
      const isLogout = util.getUrlParam('logout');
      const forward = String(util.getUrlParam('forward'));
      const forwardStr =
        forward.length === 0 || forward.includes('null')
          ? ''
          : `?forward=${forward}`;

      // 带登出标志说明是登出后跳到登录页 直接去掉登出标志 无刷新替换链接 体验比较好
      if (isLogout) {
        window.history.replaceState(null, '', `${Page.login}${forwardStr}`);
      }
      window.scrollTo(0, 0);

      if (navigator.userAgent.includes('OKApp')) {
        window.jsbridge
          .getToken()
          .then((appToken) => {
            localStorage.setItem('token', appToken);
            // 需要token的页面 没有用户token 跳转到登录页
            const token = Storage.get('token');
            if (!this.props.notAuth && (!token || token.length === 0)) {
              window.location.href = `${Page.login}?forward=${window.location.pathname}${window.location.search}${window.location.hash}`;
              resolve(false);
            } else if (this.props.notAuth && token && token.length !== 0) {
              // 不需要token的页面 有token 跳币币
              window.location.href = Page.root;
              resolve(false);
            }
            // 子账户拦截路由
            if (!subAccountIntercept()) {
              resolve(false);
            }
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            resolve(false);
          });
      } else {
        const token = Storage.get('token');
        // 需要token的页面 没有用户token 跳转到登录页
        if (!this.props.notAuth && (!token || token.length === 0)) {
          window.location.href = `${Page.login}?forward=${window.location.pathname}${window.location.search}${window.location.hash}`;
          resolve(false);
        } else if (this.props.notAuth && token && token.length !== 0) {
          // 不需要token的页面 有token 跳币币
          window.location.href = Page.root;
          resolve(false);
        }
        // 子账户拦截路由
        if (!subAccountIntercept()) {
          resolve(false);
        }
        resolve(true);
      }
    });
  };

  render() {
    return <Route {...this.props} />;
  }
}
